import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgName = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 8a2.666 2.666 0 1 0 0-5.333A2.666 2.666 0 1 0 8 8zm0 1.333c-1.78 0-5.333.894-5.333 2.667v1.333h10.666V12c0-1.773-3.553-2.667-5.333-2.667z",
		fillRule: "nonzero"
	})
});
export default SvgName;
